export const LOCALSTORAGE_WORKSPACE_VIEWS_KEY = 'qms/WORKSPACE_VIEWS';

export const SET_WORKSPACE_VIEW_FOR_ROUTE = 'SET_WORKSPACE_VIEW_FOR_ROUTE';
